import script from "./Exercise.vue?vue&type=script&setup=true&lang=ts"
export * from "./Exercise.vue?vue&type=script&setup=true&lang=ts"

import "./Exercise.vue?vue&type=style&index=0&id=365e5da8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365e5da8"]])

export default __exports__